import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../GlobalProvider";
import { PopupContext } from "../LoginPopup/LoginPopupContext";

const ImageGallery = ({ allImages }) => {
  const [visibleImages, setVisibleImages] = useState([]);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const loader = useRef(null);
  const { setLoginPop } = useContext(GlobalContext);
  const { openPopup, loggedIn, isLoggedOut } = useContext(PopupContext);
  const [isLoggedIn, setIsLoggedIn] = useState(
    !!sessionStorage.getItem("loggedIn")
  );

  const IMAGES_PER_PAGE = 50;

  const handleError = (e) => {
    e.target.onerror = null;
    e.target.src = require("../../assets/images/no_image.jpg");
  };

  useEffect(() => {
    const loadImages = () => {
      const newImages = allImages.slice(0, page * IMAGES_PER_PAGE);
      setVisibleImages(newImages);
    };
    loadImages();
  }, [page, allImages]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setPage((prev) => prev + 1);
        }
      },
      { threshold: 1 }
    );

    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      if (loader.current) observer.unobserve(loader.current);
    };
  }, []);

  const handlePlayNow = (item) => {
    navigate(`/live_casinoInPlay/${item._id}`);
  };

  return (
    <>
      {visibleImages.map((item, index) => (
        <div className="col" key={index}>
          <Link>
            <img
              src={item.url_thumb}
              onError={handleError}
              alt={item.game_name}
              decoding="async"
              loading="lazy"
            />
          </Link>
          <div className="title">{item.game_name}</div>
          <div className="login-btn-overlay">
            {loggedIn || isLoggedIn ? (
              <button onClick={() => handlePlayNow(item)} className="btn">
                Play now
              </button>
            ) : (
              <button onClick={openPopup} className="btn">
                Login to continue
              </button>
            )}
          </div>
        </div>
      ))}
      <div ref={loader} />
    </>
  );
};

export default ImageGallery;
